import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = ["innerHTML"]

import {onMounted, ref} from "vue";
import {MiscService} from "@/utilities/services/entities/MiscService";


export default /*#__PURE__*/_defineComponent({
  __name: 'Changelog',
  setup(__props) {

const logHtml = ref("");
const miscService = new MiscService();

onMounted(async()=>{
  const changelogResp = await miscService.getChangelog();

  logHtml.value = changelogResp.log; //TODO is this xss-save???
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('changelog.title')), 1)
    ]),
    _createElementVNode("div", {
      class: "contentBox text-grey changelog",
      innerHTML: logHtml.value
    }, null, 8, _hoisted_2)
  ]))
}
}

})